import { FillItemContent, MutationType, PayloadEmitSource, } from '@standardnotes/models';
import { ContentType, Result } from '@standardnotes/domain-core';
export class ReplaceContactData {
    constructor(mutator, sync, findContact) {
        this.mutator = mutator;
        this.sync = sync;
        this.findContact = findContact;
    }
    async execute(data) {
        const contactResult = this.findContact.execute({ userUuid: data.contactUuid });
        if (contactResult.isFailed()) {
            const newContact = await this.mutator.createItem(ContentType.TYPES.TrustedContact, FillItemContent(data), true);
            await this.sync.sync();
            return Result.ok(newContact);
        }
        const existingContact = contactResult.getValue();
        if (existingContact.isMe) {
            return Result.fail('Cannot replace data for me contact');
        }
        const updatedContact = await this.mutator.changeItem(existingContact, (mutator) => {
            mutator.name = data.name;
            mutator.replacePublicKeySet(data.publicKeySet);
        }, MutationType.UpdateUserTimestamps, PayloadEmitSource.RemoteRetrieved);
        await this.sync.sync();
        return Result.ok(updatedContact);
    }
}
